module.exports = __webpack_public_path__ + "static/timeline1996-6aedf924f25a0e1da9b26bb242b4fb55.jpeg";